/**
 * Website Based Rules Constants.
 */
import { __ } from "@wordpress/i18n";

export const WEBSITE_BEHAVIOR = [
	{
		id: "DynamicLink",
		name: __("Dynamic Link", "dxp"),
		typeID: "WebsiteBehavior",
		multi: true,
		details:
			"This rule applies to visitors that are on a page with a dynamic link, such as UTM parameters commonly used in marketing campaigns. <br> Learn more about UTM parameters & dynamic links <a href='https://blog.hubspot.com/marketing/what-are-utm-tracking-codes-ht' target='_blank' rel='nofollow' title='What are UTM parameters?'>here</a>.",
	},
	{
		id: "DateTime",
		multi: true,
		name: __("Date & Time Period", "dxp"),
		typeID: "WebsiteBehavior",
		details:
			"This rule applies to visitors that are visiting your website within the time & date period you select above.",
	},
	{
		id: "DateTimeSchedule",
		name: __("Date & Time Schedule", "dxp"),
		typeID: "WebsiteBehavior",
		premium: true,
		details:
			"This rule applies to visitors that are visiting your website during the schedule you select above.",
	},
	{
		id: "VisitedPages",
		name: __("Visited Page", "dxp"),
		typeID: "WebsiteBehavior",
		details:
			"This rule applies to visitors that have previously visited a page on your website.",
	},
];
